module.exports = __webpack_public_path__ + "img/zhuanpanchoujiang.817b9979.png";